import { useEffect, useState } from 'react';

const DEFAULT_AUTO_DISMISS_MS = 3000;
const DEFAULT_EXIT_MS = 180;

interface Props {
    autoDismiss?: boolean;
    onDismiss: () => void;
}

export function useTimedNotificationDismiss({ autoDismiss, onDismiss }: Props) {
    const [isClosing, setIsClosing] = useState(false);
    const [isOverlayShrinking, setIsOverlayShrinking] = useState(false);

    useEffect(() => {
        setIsClosing(false);
        setIsOverlayShrinking(false);

        if (!autoDismiss) return undefined;

        const overlayFrame = requestAnimationFrame(() => setIsOverlayShrinking(true));
        const beginExit = setTimeout(
            () => setIsClosing(true),
            Math.max(DEFAULT_AUTO_DISMISS_MS - DEFAULT_EXIT_MS, 0)
        );
        const finalDismiss = setTimeout(onDismiss, DEFAULT_AUTO_DISMISS_MS);

        return () => {
            cancelAnimationFrame(overlayFrame);
            clearTimeout(beginExit);
            clearTimeout(finalDismiss);
        };
    }, [autoDismiss, onDismiss]);

    return { autoDismissMs: DEFAULT_AUTO_DISMISS_MS, isClosing, isOverlayShrinking };
}
